// extracted by mini-css-extract-plugin
export default {"skeleton":"euLqWPgdAat2J9U","wave":"AJHkiisafF2I62r"};